import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RefactorCardHeaderComponent } from './shared/refactor-card-header/refactor-card-header.component';


@Component({
  selector: 'app-refactor',
  standalone: false,
  templateUrl: './refactor.component.html',
  styleUrl: './refactor.component.scss'
})
export class RefactorComponent {
  currentAgent: string = 'refactor'; // Aquí puedes establecer el valor inicial o detectarlo desde la ruta.
  refactorHeaderComponent = RefactorCardHeaderComponent;
  
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    // Aquí puedes actualizar `currentAgent` según la ruta actual si es necesario.
    this.route.url.subscribe(urlSegments => {
      if (urlSegments.length > 1) {
        this.currentAgent = urlSegments[1].path;
      }
    });
  }
}
